/**
 * Public newsletter render at `/c/:token`.
 *
 * No login required.  Just resolves the public token to the backend's
 * pre-rendered HTML and shows it full-bleed.
 */
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

export default function NewsletterPublicPage() {
  const { token } = useParams();
  const [search] = useSearchParams();
  const memberId = search.get('member_id');
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  const url = `${backend}/api/newsletters/c/${encodeURIComponent(token)}` +
    (memberId ? `?member_id=${encodeURIComponent(memberId)}` : '');

  return (
    <iframe
      src={url}
      title="Concierge Newsletter"
      data-testid="newsletter-public-iframe"
      style={{
        position: 'fixed', top: 0, left: 0,
        width: '100vw', height: '100vh', border: 'none',
      }}
    />
  );
}
